import type { FC } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const CancerScreeningIneligibleBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-secondary text-secondary-foreground">
      <X className="size-3" />
      {t('component:badge.cancerScreeningIneligible')}
    </Badge>
  );
};
